import * as React from 'react'
import { MenuListProps, components } from 'react-select'
import { TSkillOption } from '../skill-select.types'

export const MenuList = (props: MenuListProps<TSkillOption, true>) => (
  <components.MenuList {...props} className="py-0 max-h-[250px]" />
)
